import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
import DonutChart from '../core/DonutChart';
import { Playground } from 'docz';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "donut-chart-example"
    }}>{`Donut chart example`}</h1>
    <h2 {...{
      "id": "demo"
    }}>{`Demo`}</h2>
    <Playground __position={0} __code={'<DonutChart\n  colors={[\'red\', \'orange\', \'yellow\', \'green\']}\n  legendPosition=\"outside\"\n  resultFormatType=\"percent\"\n  toolboxTooltip={{ saveAsImage: \'saving\' }}\n  title=\"Total de S.S. por criticidade\"\n  center={[\'50%\', \'50%\']}\n  donutRadius={[\'58%\', \'70%\']}\n  tooltip={{\n    label: \'Criticidade\',\n    result: \'Total de SSs\',\n  }}\n  data={[\n    { name: \'Emergencial\', value: 120 },\n    { name: \'Alta\', value: 234 },\n    { name: \'Média\', value: 500 },\n    { name: \'Baixa\', value: 440 },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      DonutChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <DonutChart colors={['red', 'orange', 'yellow', 'green']} legendPosition='outside' resultFormatType="percent" toolboxTooltip={{
        saveAsImage: 'saving'
      }} title='Total de S.S. por criticidade' center={['50%', '50%']} donutRadius={['58%', '70%']} tooltip={{
        label: 'Criticidade',
        result: 'Total de SSs'
      }} data={[{
        name: "Emergencial",
        value: 120
      }, {
        name: "Alta",
        value: 234
      }, {
        name: "Média",
        value: 500
      }, {
        name: "Baixa",
        value: 440
      }]} mdxType="DonutChart" />
    </Playground>
    <h2 {...{
      "id": "demo-1"
    }}>{`Demo`}</h2>
    <Playground __position={1} __code={'<DonutChart\n  selectedMode\n  colors={[\'blue\', \'green\']}\n  legendPosition=\"inside\"\n  labelFontColor=\"white\"\n  centerPieValueFontSize={28}\n  resultFormatType=\"percent\"\n  toolboxTooltip={{ saveAsImage: \'saving\' }}\n  title=\"Pesquisas relacionadas\"\n  center={[\'50%\', \'50%\']}\n  donutRadius={[\'40%\', \'70%\']}\n  donutCenterValue=\"83,35%\"\n  data={[\n    { name: \'Com resposta\', value: 781 },\n    { name: \'Sem resposta\', value: 156 },\n  ]}\n/>'} __scope={{
      props,
      DefaultLayout,
      DonutChart,
      Playground,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
    <DonutChart selectedMode colors={['blue', 'green']} legendPosition='inside' labelFontColor='white' centerPieValueFontSize={28} resultFormatType='percent' toolboxTooltip={{
        saveAsImage: 'saving'
      }} title='Pesquisas relacionadas' center={['50%', '50%']} donutRadius={['40%', '70%']} donutCenterValue='83,35%' data={[{
        name: 'Com resposta',
        value: 781
      }, {
        name: 'Sem resposta',
        value: 156
      }]} mdxType="DonutChart" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      